import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { RegisterV3Api } from '@assetaccountant/api/services/register-v3.api';
import { filterAndSortByValue } from '@assetaccountant/core/utils/search-utils';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable, OperatorFunction, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-parent-group-typeahead',
  templateUrl: './parent-group-typeahead.component.html',
  styleUrls: ['./parent-group-typeahead.component.scss'],
  standalone: false,
})
export class ParentGroupTypeaheadComponent implements OnInit {
  @Input() control: FormControl<string | null>;
  @Input() registerPermission?: RegisterPermissionType;

  @ViewChild('typeahead', { static: true }) typeahead: NgbTypeahead;

  readonly RegisterPermission = RegisterPermissionType;

  click$ = new Subject<string>();
  focus$ = new Subject<string>();

  parentGroups: string[];

  searchParentGroups: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(100), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.typeahead?.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => filterAndSortByValue(this.parentGroups, term)?.slice(0, 20)),
    );
  };

  constructor(private registerV3Api: RegisterV3Api) {}

  ngOnInit() {
    this.registerV3Api
      .listParentAssetGroups()
      .subscribe(response => (this.parentGroups = response.parentGroups));
  }
}
